<template>
  <v-card
    flat
    rounded="0"
    width="100%"
    class="py-2 mb-2 medical-information-card"
    target="_blank"
    v-for="info in medicalInformations"
    :ripple="{class: 'text-transparent'}"
    :key="info.id"
    :link="info.url !== null"
    :href="info.url"
  >
    <v-card-item
      :append-icon="info.url ? 'mdi-open-in-new' : ''">
      <div class="font-size-075-rem">{{ info.formattedPublishedOn }}</div>
      <div class="text-body font-weight-bold">{{ info.text }}</div>
    </v-card-item>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"
import { MedicalInformation } from "../../stores/store_types"

export default defineComponent({
  name: "MedicalInformationCards",
  props: {
    medicalInformations: {
      type: Array<MedicalInformation>,
      required: true
    },
  },
  setup(props) {
    const medicalInformations = computed(() => props.medicalInformations as Array<MedicalInformation>)

    return {
      medicalInformations
    }
  }
})
</script>
<style lang="scss">
.medical-information-card {
  .v-card-item__append{
    i {
      color: #3ACAC9;
      font-size: 1rem;
    }
  }
  &:hover{
    background-color: #E9F9F8;
  }
}
</style>
